import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import axios from "axios";
import { DasboardService } from "../../Services/DashboardService";

Modal.setAppElement("#root");

const ProgressBar = () => {
  const [bars, setBars] = useState([]);
  const [barsALL, setBarsALL] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [totalSquare, setTotalSquare] = useState([]);

  const registeredPlot = "ylDevuPUDBzdGXM44j1P";

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await DasboardService.getTopSellingProperty(registeredPlot)
        const data = response.data;
        console.log(data);
        setTotalSquare(data.totalSquareFeet);

        const formattedBars = data.map((property) => {
          const progress =
            (property.totalRegisteredSquareFeet / property.totalSquareFeet) *
              100 || 0;

          return {
            name: property.propertyName,
            progress,
            progressValue: isNaN(progress) ? "0%" : `${Math.round(progress)}%`,
            progressSquareFeet: `${property.totalSquareFeet.toLocaleString()} Sqft`,
            registeredSquareFeet: `${property.totalRegisteredSquareFeet.toLocaleString()} Sqft`,
          };
        });

        formattedBars.sort((a, b) => b.progress - a.progress);
        const top5Bars = formattedBars.slice(0, 4);
        const top = formattedBars;
        const topColor = "#399E79";
        const defaultColor = "#EE6C4D";

        const barsWithColor = top5Bars.map((bar, index) => ({
          ...bar,
          color: index === 0 ? topColor : defaultColor,
        }));
        const barsWithAll = top.map((bar, index) => ({
          ...bar,
          color: index === 0 ? topColor : defaultColor,
        }));

        setBars(barsWithColor);
        setBarsALL(barsWithAll);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [registeredPlot]);

  function getNumericValue(progressSquareFeet) {
    const numericValue = parseFloat(progressSquareFeet.replace(/[^0-9.]/g, ""));
    return numericValue || 0;
  }

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "60%",
      height: "45%",
      overflow: "hidden",
      padding: "30px",
      position: "relative",
      backgroundColor: "white",
    },
    overlay: {
      zIndex: 10000,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
    },
  };

  function formatNumber(num) {
    if (num >= 1e7) {
      return (num / 1e7).toFixed(1).replace(/\.0$/, "") + "C";
    }
    if (num >= 1e5) {
      return (num / 1e5).toFixed(1).replace(/\.0$/, "") + "L";
    }
    if (num >= 1e6) {
      return (num / 1e6).toFixed(1).replace(/\.0$/, "") + "M";
    }
    if (num >= 1e3) {
      return (num / 1e3).toFixed(1).replace(/\.0$/, "") + "K";
    }
    return num.toString();
  }

  return (
    <div className="container xl:h-[350px] w-full 3xl:h-[440px] 4xl:h-[520px] shadow-lg rounded-xl p-6 mx-0 bg-white border border-gray-100">
      {/* Header Section */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-left text-xl font-bold text-gray-800 xl:text-lg custom-xl:text-xl 3xl:text-2xl 4xl:text-3xl">
          Top Selling Properties
        </h1>
        {barsALL.length > 4 && (
          <button
            className="text-blue-600 hover:text-blue-800 cursor-pointer text-sm font-medium transition-colors duration-200"
            onClick={handleOpenModal}
          >
            View All Properties →
          </button>
        )}
      </div>

      {/* Column Headers */}
      <div className="flex justify-between items-center mb-4 pb-2 border-b border-gray-200">
        <span className="text-sm font-semibold text-gray-600 flex-1">Property Name</span>
        <span className="text-sm font-semibold text-gray-600 w-20 text-center">Progress</span>
        <span className="text-sm font-semibold text-gray-600 w-32 text-right">Total Area</span>
      </div>

      <div className="flex flex-col overflow-y-auto h-[200px] gap-4 3xl:gap-6">
        {bars.length > 0 ? (
          bars.map((bar, index) => (
            <div key={index} className="group">
              <div className="mb-2">
                <p className="text-base font-medium text-gray-800 xl:text-sm custom-xl:text-base 3xl:text-lg 4xl:text-xl truncate">
                  {bar.name}
                </p>
              </div>
              <div className="flex items-center gap-4">
                {/* Progress Bar with Tooltip */}
                <div className="relative flex-1 bg-gray-100 h-3 rounded-full group/progress">
                  <div
                    className="h-full rounded-full transition-all duration-300 shadow-sm"
                    style={{
                      width: `${bar.progress}%`,
                      backgroundColor: bar.color,
                    }}
                  ></div>

                  {/* Enhanced Tooltip */}
                  <div className="absolute left-0 top-full mt-2 hidden group-hover/progress:block bg-gray-900 text-white text-xs px-3 py-2 rounded-lg shadow-lg z-10 whitespace-nowrap">
                    <p className="font-medium">Registered: {bar.registeredSquareFeet}</p>
                    <p className="text-gray-300">Total: {bar.progressSquareFeet}</p>
                    <div className="absolute -top-1 left-4 w-2 h-2 bg-gray-900 transform rotate-45"></div>
                  </div>
                </div>

                {/* Progress Percentage */}
                <div className="w-20 text-center">
                  <span className="text-sm font-bold text-gray-700 xl:text-xs custom-xl:text-sm 3xl:text-base 4xl:text-lg">
                    {bar.progressValue}
                  </span>
                </div>

                {/* Total Square Feet */}
                <div className="w-32 text-right">
                  <span className="text-sm font-semibold text-gray-800 xl:text-xs custom-xl:text-sm 3xl:text-base 4xl:text-lg">
                    {formatNumber(getNumericValue(bar.progressSquareFeet))}
                    <span className="text-gray-500 ml-1 text-xs">sq ft</span>
                  </span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="flex flex-col items-center justify-center py-12">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
              <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
            </div>
            <p className="text-gray-500 text-lg font-medium">No properties data available</p>
            <p className="text-gray-400 text-sm mt-1">Property sales data will appear here once available</p>
          </div>
        )}
      </div>

      {/* Enhanced Modal */}
      {isModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4"
          role="dialog"
          aria-modal="true"
          aria-labelledby="properties-modal-title"
        >
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[80vh] transform transition-all">
            {/* Modal Header */}
            <div className="flex justify-between items-center p-6 border-b border-gray-200">
              <h2
                id="properties-modal-title"
                className="text-xl font-bold text-gray-800"
              >
                All Top Selling Properties
              </h2>
              <button
                onClick={() => setIsModalOpen(false)}
                className="text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-full p-2 transition-colors"
                aria-label="Close modal"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Modal Content */}
            <div className="p-6">
              {/* Column Headers */}
              <div className="flex justify-between items-center mb-4 pb-3 border-b border-gray-200">
                <span className="text-sm font-semibold text-gray-600 flex-1">Property Name</span>
                <span className="text-sm font-semibold text-gray-600 w-20 text-center">Progress</span>
                <span className="text-sm font-semibold text-gray-600 w-32 text-right">Total Area</span>
              </div>

              <div className="overflow-y-auto max-h-[300px] custom-scrollbar">
                <div className="flex flex-col gap-4">
                  {barsALL.length > 0 ? (
                    barsALL.map((bar, index) => (
                      <div key={index} className="group">
                        <div className="mb-2">
                          <p className="text-base font-medium text-gray-800 truncate">
                            {bar.name}
                          </p>
                        </div>
                        <div className="flex items-center gap-4">
                          <div className="relative flex-1 bg-gray-100 h-3 rounded-full group/progress">
                            <div
                              className="h-full rounded-full transition-all duration-300"
                              style={{
                                width: `${bar.progress}%`,
                                backgroundColor: bar.color,
                              }}
                            ></div>
                            <div className="absolute left-0 top-full mt-2 hidden group-hover/progress:block bg-gray-900 text-white text-xs px-3 py-2 rounded-lg shadow-lg z-10 whitespace-nowrap">
                              <p className="font-medium">Registered: {bar.registeredSquareFeet}</p>
                              <p className="text-gray-300">Total: {bar.progressSquareFeet}</p>
                              <div className="absolute -top-1 left-4 w-2 h-2 bg-gray-900 transform rotate-45"></div>
                            </div>
                          </div>
                          <div className="w-20 text-center">
                            <span className="text-sm font-bold text-gray-700">
                              {bar.progressValue}
                            </span>
                          </div>
                          <div className="w-32 text-right">
                            <span className="text-sm font-semibold text-gray-800">
                              {formatNumber(getNumericValue(bar.progressSquareFeet))}
                              <span className="text-gray-500 ml-1 text-xs">sq ft</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="flex flex-col items-center justify-center py-12">
                      <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                        <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                        </svg>
                      </div>
                      <p className="text-gray-500 text-lg font-medium">No properties data available</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProgressBar;
